<div style="display: flex; flex-direction: column; height: 100%">
  <div #mapContainer style="flex-grow: 1;">
    @if (!smallWidth) {
      @if (mapHeight) {
        <app-map [height]="mapHeight"/>
      }
    }
  </div>
  @if (!smallWidth && mapHeight) {
    <app-spacer/>
  }
  <form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
    <div class="auto-direction k-gap-lg">
      @let startRental = formGroup.get('startRental')!;
      @let endRental = formGroup.get('endRental')!;
      <kendo-formfield>
        <kendo-label [text]="('rentalPointsSelection.startRentalPoint' | translate) + '*'" [for]="startRentalSelect"/>
          <select #startRentalSelect
            [ngClass]="{'invalid': startRental?.invalid && !startRental?.untouched}"
            class="k-rounded-md k-input-inner k-input-value-text k-picker k-picker-solid k-picker-md custom-icon"
            [formControlName]="'startRental'"
            (change)="startRentalSelectionChange($event)">
            <option selected disabled>{{'rentalPointsSelection.chooseStartRentalPoint' | translate}}</option>
            @for (rental of startRentalPoints(); track $index) {
              <option [value]="rental.accountId" [selected]="rental.accountId === formService.form().startRental?.accountId">
                {{ rental.city ? (rental.city + ' - ') : '' }}{{ rental.translations[lang()] || rental.businessName }}
              </option>
            }
          </select>
        @if (startRental?.invalid) {
          <kendo-formerror [textContent]="'rentalPointsSelection.errorStartRental' | translate"/>
        }
        @if (formService.form().startRental?.schedule) {
          <app-spacer/>
        }
        <app-schedule [rentalPoint]="formService.form().startRental" [date]="formService.form().from"/>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="('rentalPointsSelection.endRentalPoint' | translate) + '*'" [for]="endRentalSelect">
          <select #endRentalSelect
            [ngClass]="{'invalid': endRental?.invalid && !endRental?.untouched}"
            class="k-rounded-md k-input-inner k-input-value-text k-picker k-picker-solid k-picker-md custom-icon"
            [formControlName]="'endRental'"
            (change)="endRentalSelectionChange($event)">
            <option selected disabled>{{'rentalPointsSelection.chooseEndRentalPoint' | translate}}</option>
            @for (rental of endRentalPoints(); track $index) {
              <option [value]="rental.accountId" [selected]="rental.accountId === formService.form().endRental?.accountId">
                {{ rental.city ? (rental.city + ' - ') : '' }}{{ rental.translations[lang()] || rental.businessName }}
              </option>
            }
          </select>
        </kendo-label>
        @if (endRental?.invalid) {
          <kendo-formerror [textContent]="'rentalPointsSelection.errorReturnRental' | translate"/>
        }
        @if (formService.form().endRental?.schedule) {
          <app-spacer/>
        }
        <app-schedule [rentalPoint]="formService.form().endRental" [date]="formService.form().to"/>
      </kendo-formfield>
    </div>
    <app-spacer/>
    <div class="auto-direction k-gap-lg">
      @let from = formGroup.get('from')!;
      @let to = formGroup.get('to')!;

      <kendo-formfield>
        <kendo-label [for]="fromDate" [text]="('rentalPointsSelection.startRentalDate' | translate) + '*'"/>
        <kendo-datepicker
          #fromDate
          [size]="'medium'"
          [calendarType]="'classic'"
          [formControlName]="from | controlName"
          [enableMouseWheel]="false"
          [showOtherMonthDays]="false"
          [disabledDates]="disabledStartDates"
          (valueChange)="onStartDateChange($event)"
          [readOnlyInput]="true"
          [placeholder]="'rentalPointsSelection.chooseRentalDate' | translate"
          [min]="tomorrow"
          [format]="format"
          topView="year">
          <kendo-datepicker-messages [today]="'today' | translate"/>
        </kendo-datepicker>
        @if (from.invalid && !from.untouched) {
          @if (from?.value) {
            <kendo-formerror [textContent]="'rentalPointsSelection.errorStartDate' | translate"/>
          } @else {
            <kendo-formerror [textContent]="'rentalPointsSelection.errorMissingStartDate' | translate"/>
          }
        }
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [for]="endDate" [text]="('rentalPointsSelection.endRentalDate' | translate) + '*'"/>
        <kendo-datepicker
          #endDate
          [size]="'medium'"
          [calendarType]="'classic'"
          [formControlName]="to | controlName"
          [enableMouseWheel]="false"
          [showOtherMonthDays]="false"
          [disabledDates]="disabledEndDates"
          [readOnlyInput]="true"
          [placeholder]="'rentalPointsSelection.chooseReturnDate' | translate"
          [min]="from.value || tomorrow"
          [format]="format"
          topView="year">
          <kendo-datepicker-messages [today]="'today' | translate"/>
        </kendo-datepicker>
        @if (to.invalid && !to.untouched) {
          @if (to?.value) {
            <kendo-formerror [textContent]="'rentalPointsSelection.errorEndDate' | translate"/>
          } @else {
            <kendo-formerror [textContent]="'rentalPointsSelection.errorMissingEndDate' | translate"/>
          }
        }
      </kendo-formfield>
    </div>
    <app-spacer/>
    <app-discount-state/>
  </form>
</div>

<div kendoDialogContainer></div>
